import React from 'react';
import styled from 'styled-components';

import allbinary_logo from '../img/ab_white.svg';
import service_icons from '../service_icons';

interface FormCardProps {
    title: string;
    subtitle: string;
    logo?: string;
}

interface FormCardContainerProps {}

const FormCardContainer = styled.div<FormCardContainerProps>`
    background: inherit;
    margin: ${props => props.theme.components.formCard.top}px auto 0;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
    border-radius: ${props => props.theme.components.formCard.border_radius}px;
    width: ${props => props.theme.components.formCard.width}px;
    position: relative;
    @media only screen and (max-height: 720px) {
        margin-top: 16px;
        .flap {
            display: none !important;
        }
    }
    @media only screen and (max-height: 650px) {
        background-position: center;
        .glass,
        .logo {
            display: none !important;
        }
    }
    @media only screen and (max-width: ${props =>
            props.theme.breakpoints.md}px) {
    }
    @media only screen and (max-width: ${props =>
            props.theme.breakpoints.sm}px) {
        width: 100%;
        border-radius: 0;
        margin: 0;
        .glass {
            border-radius: 0 !important;
            height: 80px !important;
            &:before {
                width: 100% !important;
                height: 80px !important;
                left: 0px !important;
                top: 0px !important;
                filter: blur(10px) !important;
            }
        }
        .hightlight {
            border-radius: 0 !important;
            height: 80px !important;
            width: 100% !important;
        }
        .flap {
            background-color: #140b21;
            border-radius: 0 !important;
            height: 80px;
        }
    }
    .glass {
        background: inherit;
        background-position-y: -40px;
        border-radius: ${props =>
                props.theme.components.formCard.border_radius +
                'px ' +
                props.theme.components.formCard.border_radius +
                'px'}
            0 0;
        height: ${props => props.theme.components.formCard.glas_height}px;
        overflow: hidden;
        position: relative;
        &:before {
            content: '';
            width: ${props =>
                props.theme.components.formCard.width +
                props.theme.components.formCard.glas_blur_margin * 2}px;
            height: ${props =>
                props.theme.components.formCard.glas_height +
                props.theme.components.formCard.glas_blur_margin * 2}px;
            left: -${props => props.theme.components.formCard.glas_blur_margin}px;
            top: -${props => props.theme.components.formCard.glas_blur_margin}px;
            background: inherit;
            position: absolute;
            right: 0;
            bottom: 0;
            box-shadow: inset 0 0 0
                ${props => props.theme.components.formCard.glas_height}px
                rgba(255, 255, 255, 0.3);
            filter: blur(10px);
        }
        .hightlight {
            width: ${props => props.theme.components.formCard.width}px;
            height: ${props => props.theme.components.formCard.glas_height}px;
            border-radius: ${props =>
                    props.theme.components.formCard.border_radius +
                    'px ' +
                    props.theme.components.formCard.border_radius +
                    'px'}
                0 0;
            box-shadow: inset 0 2px 1px rgba(255, 255, 255, 0.3);
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
        }
    }
    .card_body {
        background-color: #fff;
        .labels {
            text-align: center;
            padding: 80px 0 12px;
            h1 {
                font-size: 38px;
                margin-bottom: 8px;
                text-transform: capitalize;
            }
            h2 {
                color: ${props => props.theme.colors.gray[0]};
                font-size: 18px;
                display: none;
                text-transform: capitalize;
            }
        }
    }
    .flap {
        display: block;
        background-image: url(${allbinary_logo});
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 46px;
        background-color: #140b21;
        border-radius: 0 0
            ${props =>
                props.theme.components.formCard.border_radius +
                'px ' +
                props.theme.components.formCard.border_radius +
                'px'};
        height: 60px;
        transition: background-color 0.2s;
        &:hover {
            background-color: ${props => props.theme.colors.gray[0]};
        }
    }

    .form_inputs {
        padding: 20px 42px;
    }

    .form_actions {
        padding: 20px 42px 30px;
        text-align: center;
        a {
            display: inline-block;
            font-size: 14px;
            padding: 12px;
            opacity: 0.7;
            width: 100%;
            font-weight: 500;
            &:hover {
                opacity: 1;
            }
        }
    }
`;

interface LogoContainerProps {
    logo: string;
}

const LogoContainer = styled.div<LogoContainerProps>`
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(${props => service_icons(props.logo)});
    border-radius: 50%;
    height: 200px;
    width: 200px;
    margin: auto;
    position: absolute;
    top: ${props => props.theme.components.formCard.glas_height - 120}px;
    left: calc(50% - 100px);
    @media only screen and (max-width: ${props =>
            props.theme.breakpoints.sm}px) {
        height: 140px;
        width: 140px;
        left: calc(50% - 70px);
        top: 14px;
    }
`;

const FormCard: React.StatelessComponent<FormCardProps> = ({
    title,
    subtitle,
    logo,
    children,
}) => (
    <FormCardContainer>
        <div className="glass">
            <div className="hightlight" />
        </div>
        <LogoContainer className="logo" logo={logo ? logo : ''} />
        <div className="card_body">
            <div className="labels">
                <h1>{title ? title : '-'}</h1>
                <h2>{subtitle}</h2>
            </div>
            <div className="children">{children}</div>
        </div>
        <a className="flap" target="_blank" href="https://www.allbinary.se" />
    </FormCardContainer>
);

export default FormCard;



// WEBPACK FOOTER //
// ./src/components/FormCard.tsx